<template lang="pug">
    .zoom-controll
      .button.toggle-sound(@click="onSoundClick", :class="{light: soundEnabled}")
      .button.zoom-in(@click="updateZoom(1)",
        ga-category="scene",
        ga-label="zoomIn")
      .button.zoom-out(@click="updateZoom(-1)",
        ga-category="scene",
        ga-label="zoomOut")
      .button.fullscreen(@click="onFullScreenClick", v-if="!isIframeMode",
        ga-category="scene",
        ga-label="fullScreen")
      audio(:src="bgMusicUrl", loop, ref="bgMusic", style="display: none")
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'ZoomControll',
  data() {
    return {
      soundEnabled: false,
      volume: 0,
      isIOS: false,
    }
  },
  mounted() {
    const toMatch = [
      /iPhone/i,
      /iPad/i,
      /iPod/i
    ];

    this.isIOS = toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
    document.addEventListener('fullscreenchange', this.fullscreenChange)
  },
  destroyed() {
    document.removeEventListener('fullscreenchange', this.fullscreenChange);
  },
  computed: {
    ...mapGetters(['zoom', 'fullScreen', 'isIframeMode', 'carModel']),
    bgMusicUrl () {
      return '/music/' + this.carModel + '.mp3'
    }
  },
  methods: {
    ...mapActions(['setZoom', 'setFullScreen']),

    fullscreenChange() {
      if (document.fullscreenElement == null) {
        this.setFullScreen(false)
      }
    },
    updateZoom(val) {
      this.setZoom(val)
      this.$nextTick(() => { this.setZoom(null) })
    },
    onSoundClick() {
      this.soundEnabled = !this.soundEnabled
      if (this.$refs.bgMusic.paused) {
        this.$refs.bgMusic.play()
      } else if (this.isIOS) {
        this.$refs.bgMusic.pause()
      }
      if (!this.isIOS) this.updateVolume()
    },
    updateVolume() {
      const toVolume = this.soundEnabled ? 1 : 0
      const audioElement = this.$refs.bgMusic;
      let volume
      if (audioElement.volume < toVolume) {
        volume = audioElement.volume + 0.05
        if (volume > 1) volume = 1
      } else {
        volume = audioElement.volume - 0.05
        if (volume < 0) volume = 0
      }

      if (Math.abs(toVolume - volume) < 0.05) {
        volume = toVolume
      }
      else {
        setTimeout(() => {
          this.updateVolume()
        }, 100)
      }

      audioElement.volume = volume
    },
    onFullScreenClick() {
      const el = document.querySelector('#app')
      if (document.webkitRequestFullscreen) {
        if (document.webkitFullscreenElement) {
          document.webkitCancelFullScreen()
          this.setFullScreen(false)
        } else {
          this.setFullScreen(true)
          const el = document.documentElement
          el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
        }
      } else if (el.requestFullscreen) {
        if (!this.fullScreen) {
          this.setFullScreen(true)
          el.requestFullscreen()
        } else {
          this.setFullScreen(false)
          document.exitFullscreen()
        }
      } else {
        this.setFullScreen(!this.fullScreen)
      }
    }
  }
}
</script>
